<template>
  <h2>Coming soon...</h2>
</template>

<script>
export default {
  name: 'ArtistAbout'
}
</script>